<template>
  <HeaderApp />
  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      ($store.getters['isRtl'] ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("add_income") }}
      </h1>
    </div>

    <!-- Form Section -->
    <div class="px-6 py-4">
      <div class="">
        <form @submit="addSaleItem">
          <div class="grid gap-x-6 mb-6 md:grid-cols-2">
            <BaseInput
              v-model="inc_amount"
              :label="$t('money_amount')"
              :placeholder="$t('income_amount')"
              :rules="rules"
              type="number"
              :isError="
                checkRulesIsError(inc_amount, 'add', this.rules).isError
              "
              :errorMsg="
                checkRulesIsError(inc_amount, 'add', this.rules).errorMsg
              "
            />
            <DropdownInput
              v-model="cur_id"
              :label="$t('currency_type')"
              :items="convertToListIdValue"
              :placeholder="$t('choose_currency')"
              :rules="rules_dropdown"
              :isError="
                checkRulesIsError(cur_id, 'add', this.rules_dropdown).isError
              "
              :errorMsg="
                checkRulesIsError(cur_id, 'add', this.rules_dropdown).errorMsg
              "
            /><DropdownInput
              v-model="ic_id"
              :label="$t('income_category')"
              :placeholder="$t('choose_income_category')"
              :rules="rules_dropdown"
              :items="convertToListIdValueIncomeCategory"
              :isError="
                checkRulesIsError(ic_id, 'add', this.rules_dropdown).isError
              "
              :errorMsg="
                checkRulesIsError(ic_id, 'add', this.rules_dropdown).errorMsg
              "
              linkDrop="/income-category"
            /><DropdownInput
              v-model="bo_id"
              :label="$t('income_box')"
              :placeholder="$t('income_box')"
              :rules="rules_dropdown"
              :items="convertToListIdValueBoxes"
              :isError="
                checkRulesIsError(bo_id, 'add', this.rules_dropdown).isError
              "
              :errorMsg="
                checkRulesIsError(bo_id, 'add', this.rules_dropdown).errorMsg
              "
              linkDrop="/all-box"
            />
            <div class="mb-6">
              <div class="flex">
                <div class="w-full">
                  <DropdownInput
                    v-model="cu_id"
                    :label="$t('customer')"
                    :placeholder="$t('choose_if_your_income_is_from_customer')"
                    :items="convertToListIdValueCustomers"
                    :rules="rules_dropdown"
                    :isError="
                      checkRulesIsError(cu_id, 'add', this.rules_dropdown).isError
                    "
                    :errorMsg="
                      checkRulesIsError(cu_id, 'add', this.rules_dropdown).errorMsg
                    "
                  />
                </div>
                <div class="w-2"></div>
                <a
                  class="w-2/12 lg:w-1/12 text-white text-2xl my-9 bg-primaryColor p-1 rounded-lg hover:shadow-md text-center"
                  target="_blank"
                  href="/customer"
                >
                  +
                </a>
              </div>
            </div>
            <BaseInput
              v-model="inc_wasl"
              :label="$t('income_invoice_number')"
              :placeholder="$t('income_invoice_number')"
              :rules="no_rule"
              :isError="
                checkRulesIsError(inc_wasl, 'add', this.no_rule).isError
              "
              :errorMsg="
                checkRulesIsError(inc_wasl, 'add', this.no_rule).errorMsg
              "
            />
            <BaseInput
              v-model="created_at"
              type="date"
              :label="$t('income_date')"
              :placeholder="$t('income_date')"
              :rules="no_rule"
              :isError="
                checkRulesIsError(created_at, 'add', this.no_rule).isError
              "
              :errorMsg="
                checkRulesIsError(created_at, 'add', this.no_rule).errorMsg
              "
            />
            <FileInput
              :label="$t('income_photo')"
              :placeholder="$t('choose_income_photo')"
              @change="onChange"
            />
            <TextAreaInput
              v-model="inc_note"
              :label="$t('note')"
              :placeholder="$t('note')"
              :rules="no_rule"
              :isError="
                checkRulesIsError(inc_note, 'add', this.no_rule).isError
              "
              :errorMsg="
                checkRulesIsError(inc_note, 'add', this.no_rule).errorMsg
              "
            />
          </div>

          <ButtonInput
            type="button"
            @click="addSaleItem"
            :label="$t('add')"
            :isLoading="isBtnLoading"
          />
        </form>
      </div>
    </div>
  </div>

  <ResultDialog ref="ResultDialog"></ResultDialog>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import FileInput from "../../components/Inputs/FileInput.vue";
import { formatDate } from "../../utils/functions";
import { CURRENCYS } from "../../constants/config";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import DropdownInput from "../../components/Inputs/DropdownInput.vue";
export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    ButtonInput,
    ResultDialog,
    TextAreaInput,
    DropdownInput,
    FileInput,
  },
  data() {
    return {
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      no_rule: [],
      isSubmited: false,
      currencys: CURRENCYS,
      rules_dropdown: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_choose_an_option");
        },
      ],
      cur_id: "",
      ic_id: "",
      bo_id: "",
      cu_id: "",
      inc_note: "",
      inc_wasl: "",
      inc_amount: "",
      created_at: "",
      inc_image: "",
    };
  },
  created() {
    this.$store.dispatch("all_box/getBoxes");
    this.$store.dispatch("income_category/getIncomeCategory");
    this.$store.dispatch("customer/getCustomers");
    this.$store.dispatch("navbar/getItems");
  },

  computed: {
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isBtnLoading() {
      return this.$store.state.add_income.isBtnLoading;
    },
    convertToListIdValue() {
      var list = [];
      for (const item of this.currencys) {
        list.push({
          id: item.cur_id,
          value: this.$t(item.cur_name),
        });
      }

      return list;
    },
    convertToListIdValueBoxes() {
      var boxes = this.$store.state.all_box.boxes;
      var list = [];
      for (const item of boxes) {
        list.push({
          id: item.bo_id,
          value: item.bo_name,
        });
      }

      return list;
    },
    convertToListIdValueCustomers() {
      var customers = this.$store.state.customer.customers;
      var list = [];
      for (const item of customers) {
        list.push({
          id: item.cu_id,
          value: item.cu_name,
        });
      }

      return list;
    },
    convertToListIdValueIncomeCategory() {
      var incomeCategory = this.$store.state.income_category.incomeCategory;
      var list = [];
      for (const item of incomeCategory) {
        list.push({
          id: item.ic_id,
          value: item.ic_name,
        });
      }

      return list;
    },
  },

  methods: {
    onChange(files) {
      this.inc_image = files[0] || null;
    },
    formatDate(date) {
      return formatDate(date);
    },

    async addSaleItem(e) {
      e.preventDefault();

      //check form validation
      if (this.$store.state.add_income.isBtnLoading) return;

      this.isSubmited = true;
      if (
        this.checkRulesIsError(this.cur_id, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.ic_id, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.bo_id, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.inc_amount, "add", this.rules).isError
      ) {
        return;
      }
      this.$store.state.add_income.isBtnLoading = true;
      var res = await this.$store.dispatch("add_income/addNewItem", {
        cur_id: this.cur_id,
        ic_id: this.ic_id,
        bo_id: this.bo_id,
        cu_id: this.cu_id,
        inc_note: this.inc_note,
        inc_wasl: this.inc_wasl,
        inc_amount: this.inc_amount,
        inc_main_currency_price: this.$store.state.navbar.dp_price,
        created_at: this.created_at,
        inc_image: this.inc_image,
      });
      if (res.status == 200) {
        this.inc_amount = "";
        this.inc_note = "";
        this.inc_wasl = "";

        this.isSubmited = false;
      }
      this.isSubmited = false;
    },
    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      for (const rule of rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
  },
};
</script>
